import { ModalIOF } from '@old/ui/modal/modal';
import { Stack, Typography, Box, Button, GridLegacy as Grid, Chip, Divider } from '@mui/material';
import { useService } from '@old/hooks/use-service';
import { useState } from 'react';

// LaSegunda
import redSojaIcon from '../../../assets/svg/icons-species-red/soja-red.svg';
import redMaizIcon from '../../../assets/svg/icons-species-red/maiz-red.svg';
import redTrigoIcon from '../../../assets/svg/icons-species-red/trigo-red.svg';
import redCebadaIcon from '../../../assets/svg/icons-species-red/cebada-red.svg';
import redGirasolIcon from '../../../assets/svg/icons-species-red/girasol-red.svg';
// Galicia
import sojaGaliciaIcon from '../../../assets/svg/icons-species-galicia/soja-galicia.svg';
import maizGaliciaIcon from '../../../assets/svg/icons-species-galicia/maiz-galicia.svg';
import trigoGaliciaIcon from '../../../assets/svg/icons-species-galicia/trigo-galicia.svg';
import cebadaGaliciaIcon from '../../../assets/svg/icons-species-galicia/cebada-galicia.svg';
import girasolGaliciaIcon from '../../../assets/svg/icons-species-galicia/girasol-galicia.svg';
// Federación Patronal
import sojaFedPat from '../../../assets/svg/icons-species-fedpatronal/soja-fedpatronal.svg';
import maizFedPat from '../../../assets/svg/icons-species-fedpatronal/maiz-fedpatronal.svg';
import trigoFedPat from '../../../assets/svg/icons-species-fedpatronal/trigo-fedpatronal.svg';
import cebadaFedPat from '../../../assets/svg/icons-species-fedpatronal/cebada-fedpatronal.svg';
import girasolFedPat from '../../../assets/svg/icons-species-fedpatronal/girasol-fedpatronal.svg';

// Swiss Re
import porotoSwissRe from '../../../assets/svg/icons-species-swissre/bean-swissre.svg';
import maizSwissRe from '../../../assets/svg/icons-species-swissre/maiz-swissre.svg';
import arrozSwissRe from '../../../assets/svg/icons-species-swissre/rice-swissre.svg';
import sojaSwissRe from '../../../assets/svg/icons-species-swissre/soja-swissre.svg';
import trigoSwissRe from '../../../assets/svg/icons-species-swissre/trigo-swissre.svg';

import { useGlobalStore } from '@old/global-store/use-store';
import { insuranceValidateService } from '@old/services/integration/insurance/validate/validate-insurance';
import { ArgInsuranceBodyModal } from './arg-insurance-form';
import { BrInsuranceBodyModal } from './br-insurance-form';
import i18n from '../../../libs/language';

type PriceData = {
  [key: number | string]: number;
};
type GenericInsuranceModalProps = {
  type: 'lasegunda' | 'galicia' | 'fedpatronal' | 'swissre';
  open: boolean;
  setOpen: (open: boolean) => void;
  silobagIds?: string[];
  silobagData: { id: string; species: number; speciesName: string; tons: number }[];
  vigency: number;
  priceData: PriceData;
  typeCoin: number;
};

export function GenericInsuranceModal(props: GenericInsuranceModalProps) {
  const { country_id } = useGlobalStore();

  const { open, setOpen, silobagIds, vigency, typeCoin, priceData, silobagData } = props;
  const [isQuoting, setIsQuoting] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const [silobagsWithError, setSilobagsWithError] = useState<{ id: string; code: number }[]>([]);

  // TODO: continuar a partir desde acá, acá llega la respuesta
  const { trigger: insuranceValidateTrigger } = useService(insuranceValidateService, {
    onSuccess: () => {
      setIsQuoting(true);
    },
    onError: (error) => {
      setSilobagsWithError(
        // @ts-expect-error WIP - falta definir bien el tipo de error que devuelve el servicio de validación
        error.data.response
          // @ts-expect-error WIP - falta definir bien el tipo de error que devuelve el servicio de validación
          .filter((e) => e.error)
          // @ts-expect-error WIP - falta definir bien el tipo de error que devuelve el servicio de validación
          .map((err) => ({ id: err.silobag_id, code: err.message.code }))
      );
    },
  });

  const ENTITY_MAP = {
    lasegunda: 'La Segunda',
    galicia: 'Galicia Seguros',
    fedpatronal: 'Federación Patronal',
    swissre: 'Swiss Re',
  };
  const LOGO_MAP = {
    lasegunda: 'https://iofbucket.s3.amazonaws.com/logo/logo+la+segunda+rojo.svg',
    galicia: 'https://iofbucket.s3.amazonaws.com/logo/Logo%20Galicia%20Seguros%20Color.svg',
    fedpatronal: 'https://iofbucket.s3.amazonaws.com/logo/Logo%20FedPat%20Color.svg',
    swissre: 'https://iofbucket.s3.amazonaws.com/logo/SwissRE%20Logo%20Color.svg',
  };
  const SPECIES_MAP = {
    lasegunda: {
      soja: redSojaIcon,
      maiz: redMaizIcon,
      trigo: redTrigoIcon,
      cebada: redCebadaIcon,
      girasol: redGirasolIcon,
    },
    galicia: {
      soja: sojaGaliciaIcon,
      maiz: maizGaliciaIcon,
      trigo: trigoGaliciaIcon,
      cebada: cebadaGaliciaIcon,
      girasol: girasolGaliciaIcon,
    },
    fedpatronal: {
      soja: sojaFedPat,
      maiz: maizFedPat,
      trigo: trigoFedPat,
      cebada: cebadaFedPat,
      girasol: girasolFedPat,
    },
    swissre: {
      feijão: porotoSwissRe,
      milho: maizSwissRe,
      arroz: arrozSwissRe,
      soja: sojaSwissRe,
      trigo: trigoSwissRe,
    },
  };
  const CALL_TO_ACTION_STYLES_MAP = {
    lasegunda: {
      primary: '#E20039',
      background: 'linear-gradient(45deg, #E20039 0%, #E20039 67%, #facdd4 100%)',
      color: '#FFFFFF',
      boxShadow: '0px 3px 6px rgba(226, 0, 57, 0.4)',
      '&:hover': {
        background: 'linear-gradient(45deg, #fa144e 0%, #fa144e 67%, #facdd4 100%)',
        boxShadow: '2px 5px 8px rgba(226, 0, 57, 0.6)',
      },
    },
    galicia: {
      primary: '#fa6503',
      background: 'linear-gradient(60deg, #fa6503 0%, #fa6503 70%, #0073ce 100%)',
      boxShadow: '0px 3px 6px rgba(250, 101, 3, 0.4)',
      '&:hover': {
        background: 'linear-gradient(60deg, #FF8A1E 0%, #FF8A1E 70%, #0073ce 100%)',
        boxShadow: '2px 5px 8px rgba(250, 101, 3, 0.6)',
      },
    },
    fedpatronal: {
      primary: '#004AAD',
      background: 'linear-gradient(45deg, #004AAD 0%, #004AAD 67%, #A9C4F5 100%)',
      boxShadow: '0px 3px 6px rgba(0, 74, 173, 0.4)',
      '&:hover': {
        background: 'linear-gradient(45deg, #0066FF 0%, #0066FF 67%, #A9C4F5 100%)',
        boxShadow: '2px 5px 8px rgba(0, 74, 173, 0.6)',
      },
    },
    swissre: {
      primary: '#4a5f59',
      background: 'linear-gradient(45deg, #4a5f59 0%, #627d77 67%, #CEDBD8 100%)',
      boxShadow: '0px 3px 6px rgba(98, 125, 119, 0.4)',
      '&:hover': {
        background: 'linear-gradient(45deg, #5a6f69 0%, #728d87 67%, #CEDBD8 100%)',
        boxShadow: '2px 5px 8px rgba(98, 125, 119, 0.6)',
      },
    },
  };

  const TEXT_MAPS = {
    lasegunda: {
      coverage:
        'Daños ocasionados exclusivamente a los granos almacenados por incendio, rayo, explosión, vandalismo, malevolencia, huelga, lock out, impactos de aeronaves, vehículos terrestes y humo.',
    },
    galicia: {
      coverage:
        'Incendio y Aliados, Huracán, Vendaval, Ciclón o Tornado, Granizo, Robo. Modalidad a prorrata.',
    },
    fedpatronal: {
      coverage:
        'Daños causados a los granos objeto del seguro por acción directa o indirecta del fuego, rayo y/o explosión, medios para extinguirlo, huelga, tumulto popular, impacto de aeronaves y vehículos terrestres.',
    },
    swissre: {
      coverage:
        'Exclusivo para os grãos armazenados nos silos bolsa selecionados, para danos ocorridos devido a:',
    },
  };

  const insurance = {
    enterprise: ENTITY_MAP[props.type],
    logo: LOGO_MAP[props.type],
    speciesIcon: {
      ...SPECIES_MAP[props.type],
    },
    coverages: TEXT_MAPS[props.type].coverage,
    callToActionStyles: CALL_TO_ACTION_STYLES_MAP[props.type],
  };

  const handleQuoteClick = () => {
    insuranceValidateTrigger({ query: silobagIds ?? [] }, { type: props.type });
  };

  const effectiveSilobagListIDs =
    silobagIds?.filter((id) => !silobagsWithError.some((err) => err.id === id)) ?? [];

  // Silobags que pasaron validaciones (sin errores)
  const effectiveSilobagData = silobagData.filter(
    (silobag) => !silobagsWithError.some((err) => err.id === silobag.id)
  );

  // Toneladas totales de los silobolsas válidos
  const effectiveTons = effectiveSilobagData.reduce((sum, silobag) => sum + silobag.tons, 0);

  // Suma asegurada calculada por silobolsa válido: tons * precio pizarra de su especie
  const effectiveSumAssured = effectiveSilobagData.reduce(
    (sum, silobag) => sum + silobag.tons * (priceData[silobag.species] ?? 0),
    0
  );

  const hasSilobagsWithError = silobagsWithError.length > 0;
  if (hasSilobagsWithError && !isQuoting) {
    const SILOBAG_ERROR_CODES: Record<number, string> = {
      20012: i18n.t('app.silobag_insurance.error_messages.missing_initial_humidity'),
      20013: i18n.t('app.silobag_insurance.error_messages.humidity_higher_than_limit'),
      20037: i18n.t('app.silobag_insurance.error_messages.specie_not_quote'),
      20040: i18n.t('app.silobag_insurance.error_messages.has_field_closure'),
      20076: i18n.t('app.silobag_insurance.error_messages.silobag_not_in_country'),
    };

    return (
      <ModalIOF open={open} ModalIsOpen={setOpen}>
        <ModalIOF.Body>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box
              sx={{
                mt: 2,
                mb: 2,
                py: 1.5,
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: insurance.callToActionStyles.primary, mb: 0.5 }}
              >
                {i18n.t('app.silobag_insurance.modal_silobag_validation.title')}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {i18n.t('app.silobag_insurance.modal_silobag_validation.description')}
              </Typography>
            </Box>
            <Box>
              <img
                src={insurance.logo}
                alt={`${insurance.enterprise} Logo`}
                style={{ width: '256px', padding: 10 }}
              />
            </Box>
          </Stack>
          <Divider sx={{ my: 1 }} />
          <Stack spacing={1.5} sx={{ my: 2, maxHeight: 320, overflowY: 'auto', pr: 0.5 }}>
            {silobagsWithError.map((silobag) => {
              const data = silobagData.find((s) => s.id === silobag.id);
              return (
                <Box
                  key={silobag.id}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 1.5,
                    borderRadius: 2,
                    border: `1px solid ${insurance.callToActionStyles.primary}40`,
                    backgroundColor: `${insurance.callToActionStyles.primary}08`,
                  }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.75} sx={{ mb: 0.5 }}>
                      <Box
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 0.5,
                          px: 1,
                          py: 0.25,
                          borderRadius: 1,
                          backgroundColor: `${insurance.callToActionStyles.primary}18`,
                          border: `1px solid ${insurance.callToActionStyles.primary}60`,
                        }}
                      >
                        <Typography
                          variant="caption"
                          fontWeight={500}
                          sx={{ lineHeight: 1, color: insurance.callToActionStyles.primary, opacity: 0.7 }}
                        >
                          ID
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={800}
                          sx={{ lineHeight: 1, color: insurance.callToActionStyles.primary }}
                        >
                          {silobag.id}
                        </Typography>
                      </Box>
                      {data && (
                        <>
                          <Box
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              px: 1,
                              py: 0.25,
                              borderRadius: 1,
                              backgroundColor: '#f1f8e9',
                              border: '1px solid #c5e1a5',
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              sx={{ lineHeight: 1, color: '#6baa00' }}
                            >
                              {data.speciesName}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              px: 1,
                              py: 0.25,
                              borderRadius: 1,
                              backgroundColor: '#e3f4fd',
                              border: '1px solid #90caf9',
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              sx={{ lineHeight: 1, color: '#22A7F0' }}
                            >
                              {data.tons} tn
                            </Typography>
                          </Box>
                        </>
                      )}
                    </Stack>
                    <Typography variant="body2" color="text.secondary">
                      {SILOBAG_ERROR_CODES[silobag.code]}
                    </Typography>
                  </Box>
                  <Chip
                    label={`#${silobag.code}`}
                    size="small"
                    variant="outlined"
                    sx={{
                      flexShrink: 0,
                      fontSize: '11px',
                      color: insurance.callToActionStyles.primary,
                      borderColor: `${insurance.callToActionStyles.primary}60`,
                    }}
                  />
                </Box>
              );
            })}
          </Stack>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="body2" sx={{ marginTop: '15px', fontStyle: 'italic', color: '#666' }}>
            {i18n.t('app.silobag_insurance.modal_silobag_validation.support_message')}
          </Typography>
          <Stack direction={'row'} justifyContent={'right'} spacing={2} sx={{ marginTop: '20px' }}>
            <Button onClick={() => setSilobagsWithError([])} sx={{ color: 'black' }}>
              {i18n.t('app.return')}
            </Button>
            <Button
              color="primary"
              variant="contained"
              disabled={effectiveSilobagListIDs.length === 0}
              onClick={() => {
                setIsQuoting(true);
              }}
              sx={{
                color: '#FFF',
                fontSize: 14,
                borderRadius: 100,
                textTransform: 'none',
                padding: '0px 30px',
                margin: '10px',
                ...insurance.callToActionStyles,
                '&:disabled': {
                  background: '#ccc',
                  boxShadow: 'none',
                },
              }}
            >
              {i18n.t('app.continue')}
            </Button>
          </Stack>
        </ModalIOF.Body>
      </ModalIOF>
    );
  }

  return (
    <ModalIOF open={open} ModalIsOpen={setOpen}>
      {!isQuoting ? (
        <>
          {/* PASO 1 */}
          <ModalIOF.HeaderCenter>
            <Box>
              <img
                src={insurance.logo}
                alt={`${insurance.enterprise} Logo`}
                style={{ width: '256px', padding: 10 }}
              />
            </Box>
          </ModalIOF.HeaderCenter>
          <ModalIOF.Body>
            <Stack direction="column" spacing={2} sx={{ textAlign: 'center' }}>
              <Typography variant="h5" sx={{ fontWeight: 500 }}>
                {i18n.t('app.silobag_insurance.insurable_grains')}
              </Typography>
              <Stack direction={'row'} justifyContent={'center'}>
                {Object.entries(insurance.speciesIcon).map(([key, icon]) => (
                  <Box key={key}>
                    <img src={icon} alt={key} style={{ width: '50px', margin: '15px 25px 10px 25px' }} />
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Stack>
            <Stack
              direction={'column'}
              justifyContent={'center'}
              sx={{ textAlign: 'center', margin: '15px' }}
            >
              <Typography variant="h5" sx={{ fontWeight: 500, marginBottom: '15px' }}>
                Coberturas
              </Typography>
              <Typography>{insurance.coverages}</Typography>
            </Stack>
            <Grid container justifyContent="space-evenly" spacing={2} sx={{ marginTop: '10px' }}>
              <Grid item xs={12} sm={8}>
                {country_id === 1 ? (
                  <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '16px' }}>
                    Adicionales Incluidos *
                  </Typography>
                ) : null}
                <Stack direction="row" sx={{ fontSize: '14px' }}>
                  {props.type === 'lasegunda' ? (
                    <>
                      <Box>
                        <ul>
                          <li>Combustión espontánea</li>
                          <li>Inundación</li>
                          <li>Gastos de vaciado y llenado de bolsas</li>
                          <li>Vendaval</li>
                        </ul>
                        <p style={{ textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>
                          Según condiciones de polizas *
                        </p>
                      </Box>
                      <ul>
                        <li>Combustión espontánea</li>
                        <li>Inundación</li>
                        <li>Gastos de vaciado y llenado de bolsas</li>
                        <li>Vendaval</li>
                      </ul>
                    </>
                  ) : null}
                  {props.type === 'galicia' ? (
                    <Box>
                      <ul>
                        <li>Fuego, Rayo y/o Explosion. Medios para extinguirlo.</li>
                        <li>Huelga y tumulto popular</li>
                        <li>Vandalismo</li>
                        <li>Humo</li>
                        <li>Combustión espontánea</li>
                      </ul>
                      <p style={{ textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>
                        Según condiciones de polizas *
                      </p>
                    </Box>
                  ) : null}
                  {props.type === 'fedpatronal' ? (
                    <Box>
                      <ul>
                        <li>Huracán, Vendaval, Ciclón y Tornado.</li>
                        <li>Granizo.</li>
                        <li>Gastos extra.</li>
                        <li>Inundación.</li>
                        <li>Robo.</li>
                        <li>Combustión espontánea.</li>
                      </ul>
                      <p style={{ textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>
                        Según condiciones de polizas *
                      </p>
                    </Box>
                  ) : null}
                  {props.type === 'swissre' ? (
                    <Box>
                      <ul>
                        <li>Incêndio/queda de raio (dentro do terreno segurado)/explosão</li>
                        <li>Vendaval, granizo, queda de aeronaves, impacto de veículos e fumaça</li>
                        <li>Alagamento/inundação</li>
                        <li>Roubo e furto de bens mediante arrombamento</li>
                        <li>Acidentes de transporte</li>
                        <li>Despesas com salvamento e recomposição de registros e documentos</li>
                      </ul>
                    </Box>
                  ) : null}
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                {props.type === 'lasegunda' ? (
                  <>
                    <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '16px' }}>
                      Opcionales *
                    </Typography>
                    <Typography sx={{ fontSize: '14px', marginTop: '15px' }}>
                      Robo de granos a primer riesgo absoluto.
                    </Typography>
                  </>
                ) : null}
                {props.type === 'galicia' ? (
                  <>
                    <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '16px' }}>
                      Provincias de cobertura
                    </Typography>
                    <ul>
                      <li>Córdoba</li>
                      <li>Santa Fe</li>
                      <li>Entre Ríos</li>
                      <li>Buenos Aires</li>
                    </ul>
                  </>
                ) : null}
                {props.type === 'fedpatronal' ? (
                  <>
                    <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '16px' }}>
                      Más Información
                    </Typography>
                    <Typography
                      sx={{ fontSize: '14px', marginTop: '15px', fontStyle: 'italic', color: '#666' }}
                    >
                      Sin información adicional proporcionada.
                    </Typography>
                  </>
                ) : null}
              </Grid>
            </Grid>
            <Stack direction={'row'} justifyContent={'right'} spacing={2}>
              <Button onClick={() => setOpen(false)} sx={{ color: 'black' }}>
                {i18n.t('app.close')}
              </Button>
              <Button
                variant="contained"
                sx={{
                  color: '#FFF',
                  fontSize: 14,
                  borderRadius: 100,
                  textTransform: 'none',
                  padding: '0px 30px',
                  margin: '10px',
                  ...insurance.callToActionStyles,
                }}
                onClick={handleQuoteClick}
              >
                {i18n.t('app.silobag_insurance.request_quote')}
              </Button>
            </Stack>
          </ModalIOF.Body>
        </>
      ) : (
        <>
          {/* PASO 2 */}
          <ModalIOF.Header>
            <Box>
              <img
                src={insurance.logo}
                alt={`${insurance.enterprise} Logo`}
                style={{ width: '256px', padding: 10 }}
              />
            </Box>
          </ModalIOF.Header>
          {!isSend ? (
            country_id === 1 ? (
              <ArgInsuranceBodyModal
                type={props.type as 'galicia'}
                setIsQuoting={setIsQuoting}
                setIsSend={setIsSend}
                setOpen={setOpen}
                silobagIds={effectiveSilobagListIDs}
                vigency={vigency}
                totalSumAssured={effectiveSumAssured}
                tons={effectiveTons}
                typeCoin={typeCoin}
                insurance={insurance}
              />
            ) : (
              <BrInsuranceBodyModal
                type={props.type as 'swissre'}
                setIsQuoting={setIsQuoting}
                setIsSend={setIsSend}
                setOpen={setOpen}
                silobagIds={effectiveSilobagListIDs}
                vigency={vigency}
                totalSumAssured={effectiveSumAssured}
                tons={effectiveTons}
                insurance={insurance}
              />
            )
          ) : (
            <ModalIOF.Body>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6" fontWeight={600}>
                  {i18n.t('app.silobag_insurance.thanks')}
                </Typography>
                <Typography
                  fontSize={'16px'}
                  fontWeight={300}
                  sx={{ marginTop: '10px', textWrap: 'balance' }}
                >
                  {i18n.t('app.silobag_insurance.contact', {
                    enterprise:
                      insurance.enterprise === 'Swiss Re' ? 'corretora Romap Seguros' : insurance.enterprise,
                  })}
                </Typography>
                <Button
                  color="error"
                  onClick={() => {
                    setIsQuoting(false);
                    setOpen(false);
                    setIsSend(false);
                  }}
                  sx={{ color: 'black', marginTop: '15px' }}
                >
                  {i18n.t('app.close')}
                </Button>
              </Box>
            </ModalIOF.Body>
          )}
        </>
      )}
    </ModalIOF>
  );
}
